import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lng", "lat", "address", "zipcode", "city", "country", "map", "form", "googlePlaceId"]

  connect() {
    this.initAutocomplete()
    this.initMap()
    this.initMarker()

    if (this.lngTarget.value.length > 0 && this.latTarget.value.length > 0) {
      this.initVenueOnMap()
      this.formTarget.classList.remove("d-none")
    }
  }

  preventSubmit(e) {
    if (e.key == "Enter") {
      e.preventDefault()
    }
  }

  // Private

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.addressTarget)
    this.autocomplete.addListener('place_changed', this.locationChanged.bind(this))
  }

  locationChanged() {
    this.formTarget.classList.remove("d-none")
    const place = this.autocomplete.getPlace()

    if (place.geometry) {
      this.lngTarget.value = place.geometry.location.lng()
      this.latTarget.value = place.geometry.location.lat()
    }

    if (place.place_id && this.hasGooglePlaceIdTarget) {
      this.googlePlaceIdTarget.value = place.place_id
    }

    this.addressTarget.value = place.name
    this.applyAddressComponents(place.address_components)
    this.initVenueOnMap()
  }

  applyAddressComponents(components) {
    const byType = Object.fromEntries(components.map(c => [c.types[0], c]))

    // Priority order: locality > postal_town (England) > administrative_area_level_3 (Italy) > administrative_area_level_2 (Spain)
    const cityType = ["locality", "postal_town", "administrative_area_level_3", "administrative_area_level_2"].find(t => byType[t])
    if (cityType) this.cityTarget.value = byType[cityType].long_name

    if (byType.postal_code) this.zipcodeTarget.value = byType.postal_code.short_name
    if (byType.country) this.selectCountry(byType.country.long_name)
  }

  selectCountry(countryName) {
    const matchingOption = this.findCountryOption(countryName)
    if (matchingOption !== null) {
      this.countryTarget.options[this.countryTarget.selectedIndex].selected = false
      matchingOption.selected = true
    }
  }

  initMap() {
    this.center = new google.maps.LatLng(47.171603, 2.644132)
    this.map = new google.maps.Map(this.mapTarget, google.maps.Map.mapOptions(this.center))
  }

  initMarker() {
    this.marker = new google.maps.Marker(
      {
        icon: google.maps.MarkerIcon,
        map: this.map,
        draggable: true,
        visible: false
      }
    )
    this.marker.addListener('dragend', this.saveMarkerPosition.bind(this))
  }

  initVenueOnMap() {
    const venuePosition = new google.maps.LatLng(this.latTarget.value, this.lngTarget.value)
    this.map.setCenter(venuePosition)
    this.map.setZoom(15)
    this.marker.setPosition(venuePosition)
    this.marker.setVisible(true)
  }

  saveMarkerPosition() {
    this.latTarget.value = this.marker.position.lat()
    this.lngTarget.value = this.marker.position.lng()
  }

  findCountryOption(countryName) {
    return Array.from(this.countryTarget.options).find(o => o.text === countryName) ?? null
  }
}
